<template>

    <ul class="categories reset">
        <li class="category" @click="toggleCategory(-1)">
            <router-link to="/product/product-center" class="category-name no-type">
                {{$t('products.allProduct')}}
            </router-link>
        </li>
        <li v-for="c in categories" v-bind:key="c.categoryId" class="category">
            <div class="category-name" @click="toggleCategory(c.categoryId)">
                {{$i18n.locale === 'zh-CN' ? c.zhName : c.enName}}
            </div>
            <el-collapse-transition>
                <ul v-show="visibleCategoryId == c.categoryId" class="types hide reset">
                    <li v-for="t in c.children" v-bind:key="t.typeId"
                        :class="'type ' + (selectedTypeId == t.typeId ? 'selected' : '')">
                        <router-link :to="`/product/product-center?typeId=${t.typeId}`">
                            {{$i18n.locale === 'zh-CN' ? t.zhName : t.enName}}
                        </router-link>
                    </li>
                </ul>
            </el-collapse-transition>
        </li>
    </ul>

</template>


<script>
    export default {
      data() {
        return {
          categories: [],
          visibleCategoryId: null,
          selectedTypeId: null
        };
      },

      created() {
        // 从缓存读取
        this.$cache
        .defineValueProvider('categories', this.loadCategories)
        .get('categories').then(types => {
          const categories = [];
          types.forEach(t => {
            let c = categories.find(c => c.categoryId === t.categoryId);
            if (!c) {
              c = {
                categoryId: t.categoryId,
                enName: t.enCategoryName,
                zhName: t.zhCategoryName,
                children: [],
              };
              categories.push(c);
            }

            if (t.typeId === this.selectedTypeId) {
              this.visibleCategoryId = t.categoryId;
            }

            c.children.push(t);
          });
          this.categories = categories;
          this.setSelectedTypeId(this.$route.query.typeId);
        });
      },

      watch: {
        $route(newValue, oldValue) {
          this.setSelectedTypeId(newValue.query.typeId);
        },
      },

      methods: {
        loadCategories() {
          return new Promise((resolve, reject) => {
            this.$ajax.get('/categories/types').then(response => {
              if (response.code !== 100) {
                reject(response);
                return;
              }
              resolve(response.data);
            });
          });
        },

        toggleCategory(categoryId) {
          if (this.visibleCategoryId === categoryId) {
            this.visibleCategoryId = null;
          } else {
            this.visibleCategoryId = categoryId;
          }

          if (categoryId === -1) {
            this.setSelectedTypeId(-1);
          }
        },

        setSelectedTypeId(typeId) {
          typeId = typeId == null ? this.selectedTypeId : typeId;
          let categoryId = -1;
          this.categories.forEach(c => {
            if (c.children.findIndex(t => t.typeId == typeId) >= 0) {
              categoryId = c.categoryId;
            }
          });

          this.visibleCategoryId = categoryId;
          this.selectedTypeId = typeId;
        }
      },
    }
</script>



<style lang="scss">

    .categories {
        width: 100%;

        .category {
            &:not(:first-child) {
                border-top: 1px solid #f0f0f0;
            }

            .category-name {
                padding: 0 50px 0 20px;
                font-size: 16px;
                font-weight: 700;
                line-height: 50px;
                overflow: hidden;
                -ms-text-overflow: ellipsis;
                text-overflow: ellipsis;
                white-space: nowrap;

                position: relative;
                &:after {
                    content: "\e84b";
                    font-family: iconfont, serif;
                    position: absolute;
                    right: 20px;
                }
                &.no-type:after {
                    display: none;
                }
            }

            .types {
                overflow: hidden;
                border: 1px solid #f0f0f0;

                .type {
                    padding: 0 20px;
                    font-size: 16px;
                    line-height: 40px;
                    &.selected {
                        color: var(--red);
                    }
                    &:first-child {
                        margin-top: 10px;
                    }
                    &:last-child {
                        margin-bottom: 10px;
                    }
                }
            }
        }
    }
</style>